<template>  
    <v-flex>
        <v-flex v-if="!saveFormVisible" xs12 style="background-color:white; border-bottom:1px solid black;">
            <v-layout align-center row xs12>    
                <v-tooltip bottom>            
                    <v-btn slot="activator" :class="mode=='polygon' ?  'accent geozone-new-button' : ''" flat @click="changeType('polygon')"><i class="fal fa-draw-polygon fa-2x"></i></v-btn>
                    <span style="font-weight:bold;">Maak POI op basis van polygon </br> Kies een aantal punten op de map om een omtrek te genereren</span>
                </v-tooltip>
                <v-tooltip bottom>            
                    <v-btn slot="activator" :class="mode=='circle' ?   'accent  geozone-new-button' : ''" flat  @click="changeType('circle')"><i class="fal fa-circle fa-2x"></i></v-btn>          
                    <span>Maak POI op basis van cirkel </br> Kies een centrum en radius om een omtrek te genereren</span>
                </v-tooltip>
                <v-spacer></v-spacer>     
                    <v-flex xs6 xl5 md5><label v-html="toolTip"></label></v-flex>     
                <v-spacer></v-spacer>         
                <v-btn flat @click="reset()">Reset</v-btn>
                <v-btn flat :disabled="!validForSave" @click="showSaveForm()">Naar opslaan</v-btn>                      
            </v-layout>
        </v-flex>
        <div>                
            <l-map    
                v-if="!saveFormVisible"                        
                style="min-height:420px;"
                ref="map"
                :zoom="zoom" 
                :center="mapCenter"
                :options="mapOptions"
                :bounds="bounds"
                @click="mapClicked"
                >
                <!-- <l-marker v-if="marker" :lat-lng="marker" :icon="locationIcon"></l-marker> -->
                <l-tilelayer :url="url" :attribution="attribution"></l-tilelayer>          
                <l-group v-if="!saveFormVisible">
                    <l-polyline v-if="editPolyPoints.length > 0"
                        :lat-lngs="editPolyPoints"
                        :color="editPolyPointsColor">
                    </l-polyline>
                    <l-marker 
                        v-for="(point,i) in editPolyPoints" 
                        :key="`edit_${i}`"
                        :lat-lng="marker(point.lat,point.lng)"
                        :icon="icon(editPolyPointsColor)"
                        draggable
                        @dragend="markerDragged($event, i)"
                    ></l-marker>
                </l-group>   
                <l-group v-if="saveFormVisible && mode == 'polygon'">
                    <l-polygon 
                        color="blue"
                        fillColor="blue"
                        :lat-lngs="bounds"                                
                    >      
                    </l-polygon>              
                </l-group>           
                <l-group v-if="selectedAsset && !radiusCenterPoint">
                    <l-marker
                    :lat-lng="toLatLng(selectedAsset.lat,selectedAsset.lon)"
                    :icon="assetIcon(selectedAsset)"
                    :key="selectedAsset.id"
                    @click="setMartkerOnAssetLocation(selectedAsset.lat,selectedAsset.lon)"
                    >
                        <l-tooltip>                                                          
                            {{selectedAsset.name}}</br>                              
                            {{selectedAsset.street}} {{selectedAsset.city}}</br>                            
                            <i>(klik om POI aan te maken op deze lokatie)</i>
                        </l-tooltip>                    
                    </l-marker>                    
                </l-group>
                <l-group v-if="radiusCenterPoint">
                    <l-marker  
                        :lat-lng="marker(radiusCenterPoint.lat,radiusCenterPoint.lng)"
                        :icon="icon(radiusPointColor)"
                    ></l-marker>
                    <l-circle
                        :lat-lng="[radiusCenterPoint.lat, radiusCenterPoint.lng]"
                        :radius="calculatedRadius"
                        color="#37474f"
                        fillColor="#37474f"
                        :fillOpacity="0.1"
                    />            
                </l-group>        
                <!-- Show when there are more then one search results -->    
                <l-group v-if="searchResults">
                    <l-marker 
                        v-for="(point,i) in searchResults" 
                        :key="`search_${i}`"
                        :lat-lng="marker(point.lat,point.lng)"
                        :icon="icon( point.class=='place' ? 'blue' : 'grey')"
                        @click="searchResultClicked">
                        <l-tooltip>                                                      
                            <label pl-2 v-html="formatPointName(point.name)"></label>                                
                        </l-tooltip>                    
                    </l-marker>          
                </l-group>                                         
            </l-map>
            <!-- ADDRESS FINDER ----------------------------------------------------------------------------> 
            <div class="bottombar" v-if="mode=='circle' && !radiusCenterPoint && !saveFormVisible">
                <v-layout row wrap justify-end align-center>
                    <v-flex xl-4 pl-4 pr-4 xs12>
                        <v-subheader class="pl-0">Lokatie zoeken op adres</v-subheader>
                        <v-form
                            ref="geoAddressSearch"
                            v-model="formValid"
                            lazy-validation>                                 
                            <v-layout wrap >                                            
                                <v-flex xs4 pa-2>                                
                                    <v-text-field v-model="searchStreet" 
                                                label="Straat"  
                                                solo>
                                    </v-text-field>    
                                </v-flex>
                                <v-flex xs1 pa-2>
                                    <v-text-field v-model="searchHouseNumber" 
                                                label="Huisnummer" 
                                                solo>
                                    </v-text-field>    
                                </v-flex>
                                <v-flex xs4 pa-2>
                                    <v-text-field v-model="searchCity" 
                                                label="Plaats" 
                                                required
                                                :rules="[formRules.city]"     
                                                solo>
                                    </v-text-field>
                                </v-flex>
                                <v-flex pa-2>
                                    <v-btn @click="searchPointOnAddress()" class="accent"><i class="far fa-search  fa-2x"></i></v-btn>
                                </v-flex>
                            </v-layout>  
                        </v-form>  
                    </v-flex>                
                </v-layout>               
            </div> 
            <!-- RADIUS SELECTOR ------------------------------------------------------------------------->        
            <div class="bottombar"  v-if="mode=='circle' && radiusCenterPoint && !saveFormVisible">
                <v-layout row wrap justify-end align-center>
                    <v-flex xl-4 pl-4 pr-4 xs10>
                        <v-subheader class="pl-0">Radius instellen</v-subheader>
                        <v-slider
                            v-if="radiusType=='m'"
                            v-model="radius"
                            thumb-label="always"
                            :thumb-size="24"
                            min="10"
                            max="1000"
                            step="10"
                        ></v-slider>     
                        <v-slider
                            v-if="radiusType=='km'"
                            v-model="radius"
                            thumb-label="always"
                            :thumb-size="26"
                            min="1"
                            max="100"
                            step="1"
                        ></v-slider>                          
                    </v-flex>               
                    <v-layout column xs2>
                        <v-btn small :class="radiusType=='m' ?  'accent' : ''" flat @click="changeRadiusType('m')">Meter</v-btn>
                        <v-btn small :class="radiusType=='km' ?   'accent' : ''" flat  @click="changeRadiusType('km')">Kilometer</v-btn>                            
                    </v-layout>                       
                </v-layout>               
            </div>  
            <!-- SAVEFORM ------------------------------------------------------------------------------------------------->    
            <div class="bottombar"  v-if="saveFormVisible">    
                <v-layout pa-2 wrap>
                 <v-flex xs6>                    
                    <v-form
                        ref="geoZoneForm"
                        v-model="formValid"
                        lazy-validation>                            
                        <v-flex class="py-2 px-2">
                            <v-flex sm12> 
                                <v-text-field
                                    label="Naam voor Point of interest"
                                    hint="Omschrijving voor uw point of interest"                                
                                    :rules="[formRules.name]"   
                                    v-model="name"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex>                            
                                <v-select 
                                item-value="id"
                                item-text="name"                                 
                                :items="geoZoneTypes"
                                label="Type point of interest"
                                :rules="[formRules.type]"                                   
                                v-model="geoZoneTypeId"
                                required
                                ></v-select>    
                            </v-flex>                                
                            <v-flex>
                                <v-textarea
                                    name="input-7-1"
                                    label="Omschrijving"
                                    value=""
                                    v-model="description"
                                    hint="Optionele omschrijving en/of opmerkingen voor uw poi"
                                    ></v-textarea>
                            </v-flex>                                                
                        </v-flex>     
                    </v-form>            
                </v-flex>   
                <v-flex xs6 pa-2>
                    <custom-fields 
                        :customFields="customFieldsOnGeoZone" 
                        v-model="selectedCustomFields" 
                    >
                    </custom-fields>                       
                </v-flex>                        
                </v-layout>
                <v-flex class="py-2" d-flex>
                    <v-btn @click="cancelGeoZone()">Annuleren</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="saveGeoZone()">Opslaan</v-btn>
                </v-flex>                                               
            </div>                     
        </div>         
    </v-flex>
</template>

<script>
    import Vue from 'vue'
    import { MAP_URL, colors } from '../../config'    
    import { mapGetters } from 'vuex'
    import * as types from "../../store/types"
    import MapMixin from '../../plugins/mixins/MapMixin'
    import CustomFields from "../../components/form/CustomFields"   
    import _ from 'lodash';     
    export default {
        data() {
            return {
                searchResults:[],
                searchStreet:"",
                searchHouseNumber:"",
                searchCity:"",
                formValid:true,                
                formRules:{
                    name:(value)         => {return (value) ? true : "Veld verplicht"},
                    type:(value)         => {return (value) ? true : "Veld verplicht"},                                
                    city:(value)         => {return (value) ? true : "Veld verplicht"},    
                    houseNumber:(value)  => {return (value) ? true : "Veld verplicht"},
                    street:(value)       => {return (value) ? true : "Veld verplicht"}                                
                },       
                selectedCustomFields:{},         
                name:"",
                geoZoneTypeId:null,
                description:"",
                radiusType:"m",
                radius:100,                
                editPolyPointsColor: 'green',            
                editPolyPoints:[],
                radiusPointColor: '#ff6c3d',                    
                radiusCenterPoint:null,
                mode:"circle",
                saveFormVisible:false,
                geoJson:null,
                lineDistance:null,
                squareMeasure:null,
                bounds:null,
            }
        },
        components:{
            CustomFields
        },
        computed: {
            ...mapGetters({
                geoZoneTypes: types.GEO_ZONE_TYPES,       
                geoZoneCustomFields: types.GEO_ZONE_CUSTOM_FIELDS,      
                selectedAsset: types.ASSET,
            }),       
            customFieldsOnGeoZone(){
                let custom = []
                if(!this.geoZoneCustomFields)
                    return custom;

                this.geoZoneCustomFields.forEach((field) => {
                    custom.push(field.customField)
                })
                return custom
            },                    
            calculatedRadius() {                
                return this.radiusType == 'm' ? this.radius : (this.radius*1000)
            },
            toolTip(){
                if(this.mode == ""){
                    return `<i class="fal fa-arrow-left"></i>&nbsp;&nbsp;  Kies het type point of interest die u wilt maken`
                }                                             
                else if(this.mode == "polygon"){
                    return `<i class="fal fa-arrow-down"></i>&nbsp;&nbsp;Klik minimaal 3 punten op de map aan om een zone te maken klik vervolgens 'naar opslaan'&nbsp;<i class="fal fa-arrow-right">`
                }
                else if(this.mode == "circle"){
                    if(this.searchResults.length > 0){
                        return `<i class="fal fa-arrow-down"></i>&nbsp;&nbsp;Meerdere adresssen gevonden. Klik op een punt, om deze te selecteren.`
                    }
                    else if(!this.radiusCenterPoint)
                        return `<i class="fal fa-arrow-down"></i>&nbsp;&nbsp;Klik op de map waar u het centrum van de radius wilt plaatsen of zoek op adres`
                    else
                        return `<i class="fal fa-arrow-down"></i>&nbsp;&nbsp;Kies de grote van de radius </br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  klik vervolgens 'naar opslaan' &nbsp;<i class="fal fa-arrow-right">`
                }    
            },
            validForSave(){                        
                if(this.mode == "polygon"){
                    return this.editPolyPoints.length > 2  ? true : false
                }
                else if(this.mode == "circle"){

                    return this.radiusCenterPoint ? true : false
                }
                else{
                    return false
                }
            }
        },
        mixins:[MapMixin],
        methods: {
            centerOnSearchPoints(){

                let ret = []
                this.searchResults.forEach((point) => {
                    ret.push([point.lat,point.lng])
                })
                this.bounds =  [ret]               
            },
            searchPointOnAddress(){           
                let vm = this
                this.searchResults=[]     
                this.bounds=null
                if (this.$refs.geoAddressSearch.validate()) {   
                    Vue.nextTick(function () {
                        let data = {data: {street:vm.searchStreet,houseNumber:vm.searchHouseNumber,city:vm.searchCity}}

                        vm.$store.dispatch(types.GEO_CODE_ADDRESS, data).then((result) => {
                            
                            // No results found
                            if(Object.keys(result).length == 0){
                                vm.$notify('Adres niet gevonden',{type: 'info', 'icon': 'checked'})
                            }
                            // results found
                            else{           
                                // 1 result found place directly on map                      
                                if(Object.keys(result).length == 1){
                                    vm.setRadiusPoint(result[0])
                                    vm.$notify('Adres gevonden',{type: 'success', 'icon': 'checked'})                                                    
                                }
                                else{ // more results are found show them on the map for user to choose 
                                    vm.searchResults = result
                                    vm.centerOnSearchPoints();
                                    vm.$notify('Meerdere adressen gevonden. maak een keuze op de map',{type: 'success', 'icon': 'checked'})                                                                                                                        
                                }
                            }
                        })    
                    })            
                }
            },
            setRadiusPoint(searchPoint){
                this.radiusCenterPoint = searchPoint
                this.center(searchPoint.lat, searchPoint.lng)
                this.zoom = 14;
            },
            showSaveForm(){
                this.prepareGeoJson()
                this.saveFormVisible=true
            },
            reset(){
                this.mapCenter=null
                this.bounds=null
                this.editPolyPoints=[]
                this.radiusCenterPoint=null
                this.saveFormVisible=false
                this.searchStreet=""
                this.searchHouseNumber=""
                this.searchCity=""
                this.searchResults=[]
                
                this.setDefaultCenter()
            },
            setDefaultCenter(){
                if(this.selectedAsset)
                    this.center(this.selectedAsset.lat,this.selectedAsset.lon);
                else
                    this.center(52.5, 6)
            },
            cancelGeoZone(){
                this.bounds=null
                this.saveFormVisible=false
                this.geoJSON=null
            },
            saveGeoZone(){
                let saveData = {name: this.name, 
                                description: this.description, 
                                geoZoneTypeId:this.geoZoneTypeId , 
                                shapeType:this.mode, 
                                geojson: this.geoJSON,
                                shapeData:this.shapeData}  

                if (this.$refs.geoZoneForm.validate()) {                    
                    this.$store.dispatch(types.SAVE_GEO_ZONE, {data: saveData}
                    ).then((res) => {                   
                        this.saveCustomFields(res)                        
                    })
                }
            },    
            saveCustomFields(zone){
                let obj = _.pickBy(this.selectedCustomFields, (ele) => ele != undefined)
                this.$store.dispatch(types.SAVE_GEO_ZONE_CUSTOM_FIELD_VALUES, {data: { geoZoneId: zone.id, fields: obj } }).then( () => {
                    this.$emit('isSaved', zone)
                    this.$notify('Point of interest is opgeslagen',{type: 'success', 'icon': 'checked'})
                })                                                               
            },               
            changeType(type){
                if(type == "polygon"){
                    this.radiusCenterPoint = null;                    
                }
                if(type == "circle"){
                    this.editPolyPoints = [];
                }                
                this.mode = type
            },
            changeRadiusType(type){                
                if(type == 'km' )
                    this.radius = 1
                if(type == 'm')
                    this.radius = 1000
 
                this.radiusType = type
            },
            searchResultClicked(e){
                this.searchResults=[]
                this.mapClicked(e)
            },
            mapClicked(e){          
                if(this.searchResults.length > 0){
                    return       
                }                  
                if(this.mode == 'polygon'){
                    this.editPolyPoints.push(e.latlng);
                }  
                if(this.mode == 'circle'){            

                    this.radiusCenterPoint = e.latlng;
                    console.log(this.radiusCenterPoint)
                }                              
            },
            setMartkerOnAssetLocation(lat, lng){
                this.mode = 'circle'
                this.radiusCenterPoint = {lat:lat, lng:lng}
                this.editPolyPoints=[]
            },
            icon(color){                
                //let color = '#e91e63'
        
                let html = `<div class="geozone-pin"                            
                                style="background-color:${color}">                                        
                            </div>`                
                return L.divIcon({
                    iconSize: new L.Point(20, 20),
                    iconAnchor:[10,10],                
                    html
                });
            },         
            markerDragged(event, index){                
                Vue.set(this.editPolyPoints, index, event.target._latlng)
            },                           
            prepareGeoJson(){
                if(this.mode == "polygon"){                
                    let polygon = L.polygon(this.editPolyPoints);          
                    this.geoJSON = polygon.toGeoJSON()                
                    this.bounds = this.editPolyPoints                                                                      
                }
                if(this.mode == "circle"){                
                    this.shapeData = {"latlng":this.radiusCenterPoint, "radius":this.calculatedRadius}                        
                }                
            },
            loadGeoZoneTypes(){
                if(this.geoZoneTypes.length==0){
                    this.$store.dispatch(types.GEO_ZONE_TYPES,{})
                }
            },   
            loadGeoZoneCustomFields(){
                this.$store.dispatch(types.GEO_ZONE_CUSTOM_FIELDS,{params:{include:"customField, customField.type"}}).then((temp) => {
                         
                })
            },         
            formatPointName(name){
                let items = name.split(",")                
                let result = "";                
                let itemsPerLine = Math.round(items.length/3)

                let j=0;
                for(let i=0; i < items.length; i++){
                    result += items[i]+", "
                    
                    if(j == itemsPerLine){
                        j=0
                        result += "</br>"
                    }                    
                    j++
                }
                return result
            },
            toLatLng(lat, lon){
            return L.latLng(lat, lon)
            },            
            assetIcon(asset){
                let color = '#e91e63'
                let showIdentifier = true; //this.showIdentifier
                
                if(asset.statusCode == "OK"){
                    color = colors.success
                }
                else if (asset.statusCode == "ACTION"){

                }
                else if(asset.statusCode == "ERROR_WITH_ACTION"){
                    color = "#7d46ed"
                }
                else if(asset.statusCode == "ERROR"){
                    color = colors.error
                }

                else if(asset.statusCode == "ACTION"){
                    color = colors.info
                }

                // overwrite above is applicable
                if(asset.statusColor){
                    color = asset.statusColor
                }

                let isSelected = false
                let size = (asset.group.markerSize) ? asset.group.markerSize : 26;      
                let icon = (asset.group.icon) ? asset.group.icon : null;
                let shape = (asset.group.shape) ?  (asset.group.shape) : 'square'

                let html = this.generateIcon(asset, {selected: isSelected, color: color, icon: icon, size: size, shape:shape, showIdentifier: this.showIdentifier, showPrimaryData: this.showPrimaryData})
                                            
                return L.divIcon({
                    iconSize: new L.Point(size, size),
                    iconAnchor:[(size / 2 ), ( size / 2)],
                    data: {id: asset.id, group: asset.group.name, status: asset.statusCode, color: asset.statusColor},
                    html
                });
            }                
        },
        mounted(){
            this.formatPointName("Brehmen, Verwaltungsgemeinschaft Tauberbischofsheim, Main-Tauber-Kreis, Regierungsbezirk Stuttgart, Baden-Württemberg, 97953, Duitsland");

            this.loadGeoZoneTypes()
            this.loadGeoZoneCustomFields()
            this.setDefaultCenter()
        }
    }
</script>

<style  scoped>
    
    .bottombar{
        border-top: 1px solid black;
        border-left: 1px solid black;
        position:relative;
        bottom:0;        
        background-color:white;
    }

    .fs-map-container{
        height: calc(100vh);
        overflow-y:hidden;
        z-index: 1;
        width: 100%;
      /*  margin-bottom: -212px; */
    }    
</style>